import ConfigurationEmailConfiguration from './_config/configuration.email.config';
import ConfigurationEmailRoutes from './_config/configuration.email.routes';

// Services
import ConfigurationEmailService from './services/configuration.email.service';

// Components
import ConfigurationEmailListComponent from './components/configuration-email-list';
import ConfigurationEmailSmtpFormComponent from './components/configuration-email-smtp-form';
import ConfigurationEmailFormComponent from './components/configuration-email-form';
import ModaleChooseDestinataireComponent from './components/modale-choose-destinataire';

// Validator
import ConfigurationEmailFormValidator from './components/configuration-email-form/configuration.email.form.validator';
import ConfigurationEmailSmtpFormValidator from './components/configuration-email-smtp-form/configuration.email.smtp.form.validator';
import ConfigurationEmailUtilsService from './services/configuration.email.utils.service';

const moduleName = 'app.massia.common.configuration.email';

angular
	.module(moduleName, [])
	.config(ConfigurationEmailConfiguration)
	.config(ConfigurationEmailRoutes)
	.service('ConfigurationEmailService', ConfigurationEmailService)
	.service('ConfigurationEmailUtilsService', ConfigurationEmailUtilsService)
	.component('configurationEmailList', ConfigurationEmailListComponent)
	.component('configurationEmailSmtpForm', ConfigurationEmailSmtpFormComponent)
	.component('configurationEmailForm', ConfigurationEmailFormComponent)
	.component('modaleChooseDestinataire', ModaleChooseDestinataireComponent)
	.factory('ConfigurationEmailSmtpFormValidator', ConfigurationEmailSmtpFormValidator)
	.factory('ConfigurationEmailFormValidator', ConfigurationEmailFormValidator);

export default moduleName;
